<template>
  <!--123 通栏搜索 开始-->
		<div class="search-banner">
			<div class="fm clearfix">
	            <span class="s_inp_wr fl">
	            	<div class="search_1">
						<a href="javascript:;" data-type="baidu" class="search_baidu"></a>
						<span></span>
						<div class="search_menu">
							<!--<a href="javascript:;" data-type="baidu" class="search_baidu"></a>-->
							<a href="javascript:;" data-type="sougou" class="search_sougou"></a>
							<a href="javascript:;" data-type="bing" class="search_bing"></a>
							<a href="javascript:;" data-type="360" class="search_360"></a>
						</div>
					</div>
	            	<input class="s_inp" autocomplete="off" name="q" placeholder="搜索输入 ">
	            </span>
	           	<span class="s_btn_wr fr">
	           		<a href="javascript:;" class="s_btn fr" id="s_btn">
	           			<span>搜索</span>
	           		</a>
	           	</span>
	        </div>
		</div>
		<!--123 通栏搜索 结束-->
</template>
<script>
import { search } from '../../assets/js/search.js'  

export default {
  mounted(){
    search();
  }
}
</script>
<style scoped>
  /*123 通栏搜索区块 开始*/
.search-banner{
	width: 100%;
	height: 110px;
	background: url(../../assets/123_search/search_bg.png);
	border-top: 1px solid #fafafa;
}

.fm {
    width: 1180px;
    margin: 0 auto;
    margin-top: 28px;
}
.fm:hover{
  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.03);
}

.fm .s_btn_wr .s_btn {
    display: block;
    width: 140px;
    height: 50px;
    line-height: 50px;
    background: #2f8eed;
    color: #ffffff;
    font-size: 16px;
    border-radius: 0;
    text-align: center;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
}

.fm .s_btn_wr .s_btn:hover{
	filter: brightness(1.1); 
    -webkit-filter: brightness(1.1);
}

.fm .s_btn_wr .s_btn span{
    padding-left: 26px;
    background: url(../../assets/123_search/icon_search.png) no-repeat left 3px;
}

.fm .s_inp_wr {
    border: 1px solid #ccc;
    background: #ffffff;
    width: calc(100% - 142px);
    width: -moz-calc(100% - 142px); width: -webkit-calc(100% - 142px); width: -o-calc(100% - 142px);width: -ms-calc(100% - 142px);
}

.fm .s_inp_wr .s_inp {
	float: left;
    width: calc(100% - 171px);
    width: -moz-calc(100% - 171px); width: -webkit-calc(100% - 171px); width: -o-calc(100% - 171px);width: -ms-calc(100% - 171px);
    height: 36px;
    margin: 6px 0;
    padding: 0;
    background: none;
    border: 0;
    border-left: 1px solid #ccc;
    padding-left: 10px;
    outline: 0;
    font-size: 16px;
}


.search_1 {
    float: left;
    width: 140px;
    height: 48px;
    position: relative;
}


.search_1 .search_baidu {
	width: calc(100% - 24px);
	width: -moz-calc(100% - 24px); width: -webkit-calc(100% - 24px); width: -o-calc(100% - 24px);width: -ms-calc(100% - 24px);
    height: 100%;
    display: block;
    float: left;
    background: url(../../assets/123_search/logo_baidu.png) center no-repeat;
    background-position: 16px 4px;
}

.search_1 .search_sougou {
	width: calc(100% - 24px);
	width: -moz-calc(100% - 24px); width: -webkit-calc(100% - 24px); width: -o-calc(100% - 24px);width: -ms-calc(100% - 24px);
    height: 100%;
    display: block;
    float: left;
    background: url(../../assets/123_search/logo_sougou.png) center no-repeat;
	background-position: 16px 4px;
}

.search_1 .search_bing {
	width: calc(100% - 24px);
	width: -moz-calc(100% - 24px); width: -webkit-calc(100% - 24px); width: -o-calc(100% - 24px);width: -ms-calc(100% - 24px);
    height: 100%;
    display: block;
    float: left;
    background: url(../../assets/123_search/logo_biying.png) center no-repeat;
    background-position: 16px 4px;
}

.search_1 .search_360 {
	width: calc(100% - 24px);
	width: -moz-calc(100% - 24px); width: -webkit-calc(100% - 24px); width: -o-calc(100% - 24px);width: -ms-calc(100% - 24px);
    height: 100%;
    display: block;
    float: left;
    background: url(../../assets/123_search/logo_360.png) center no-repeat;
    background-position: 16px 4px;
}

.search_1 span {
    width: 11px;
    margin-right: 10px;
    height: 100%;
    display: inline-block;
    background: url(../../assets/123_search/icon_search_arrow.png) center center no-repeat;
}

.search_1 .search_menu {
	display: none;
    z-index: 1;
    position: absolute;
    background: #fff;
    top: 48px;
    left: -1px;
    border: 1px solid #ccc;
    font-size: 0;
    width: 100%;
    overflow: auto;
    max-height: 273px;
}

.search_1 .search_menu a {
	width: 100%;
    height: 42px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: 16px center;
}
.search_1 .search_menu a.search_baidu {
    background: url(../../assets/123_search/logo_baidu.png) 16px center no-repeat;
}

.search_1 .search_menu a.search_sougou {
    background: url(../../assets/123_search/logo_sougou.png) 16px center no-repeat;
}

.search_1 .search_menu a.search_bing {
    background: url(../../assets/123_search/logo_biying.png) 16px center no-repeat;
}

.search_1 .search_menu a.search_360 {
    background: url(../../assets/123_search/logo_360.png) 16px center no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/search.vue